import { withTranslations } from '@/utils/Language';
import printButtonEn from '@/assets/i18n/printButton/en.json';
import uiEn from '@/assets/i18n/ui/en.json';

const enDefault = { ...printButtonEn, ...uiEn };

export default withTranslations(
  (lang) =>
    Promise.all([import(`@/assets/i18n/printButton/${lang}.json`), import(`@/assets/i18n/ui/${lang}.json`)]).then(([printButton, ui]) => ({
      ...printButton.default,
      ...ui.default
    })),
  enDefault
);
